import React from "react";

interface CustomIconProps {
  className?: string;
  size?: number;
}

const PromptLibraryIcon: React.FC<CustomIconProps> = ({
  className,
  size = 20,
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ width: size, height: size }}
  >
    <path
      d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="5" y="16" width="14" height="2.5" rx="0.6" fill="currentColor" />
    <rect x="5" y="12" width="14" height="2.5" rx="0.6" fill="currentColor" />
    <rect x="5" y="8" width="14" height="2.5" rx="0.6" fill="currentColor" />
    <rect x="5" y="5" width="3" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="13" y="5" width="3" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="17" y="5" width="2" height="1.5" rx="0.2" fill="currentColor" />
    <rect x="9" y="5" width="3" height="1.5" rx="0.2" fill="currentColor" />
  </svg>
);

export default PromptLibraryIcon;
